import React from "react";
import PracticeHeader from "../Header/Header";
import { Outlet } from "react-router-dom";
import "../Assessts/Styles/CommonStyles.scss";
import { ToastContainer } from "react-toastify";
const PracticeTestLayout = () => {
    return (
        <>
            <div style={{ display: "grid", gridTemplateRows: "auto 1fr", minHeight: "100vh" }}>
                <div className="w-100" style={{ position: "sticky", top: "0", zIndex: 999 }} >
                    <PracticeHeader />
                </div>
                <div style={{ flex: "1"}}> <Outlet /> <ToastContainer/> </div>
                <div className=" p-3 dflex JSBetween alignitems PTFooter">
                    <div className="dflex gap-3">
                        <span>© 2026</span>
                        <span>North South Foundation. All rights reserved.</span></div>
                    <div className="dflex gap-3">
                        <span className="text-decoration-underline">Contact Us</span>
                        <span className="text-decoration-underline">Privacy Policy</span>

                    </div>
                </div>
            </div>
        </>
    )
}
export default PracticeTestLayout;